import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  fetchCurrentSubscriptions,
  getStoreValueByProp,
  resetSubscriptions,
  setPlanChosen,
} from '../store/subscriptionsSlice';
import SubscriptionEnrollment from './Enrollment';

const mapState = R.applySpec({
  currentSubscriptions: getStoreValueByProp(['currentSubscriptions']),
  currentSubscriptionsLoading: getStoreValueByProp(['currentSubscriptionsLoading']),
  planChosen: getStoreValueByProp(['planChosen']),
});

export default connect(mapState, {
  fetchCurrentSubscriptions,
  resetSubscriptions,
  setPlanChosen,
})(SubscriptionEnrollment);
